// Angular
import { Injectable } from '@angular/core';

// Afidium
import { IConfigSharedHotel } from 'libraries/hotel/models/config-shared-hotel';
import { ICurrencies } from '../resources/hotel/ISearchResponse';
import { ICurrency, ICurrencyWithPrice } from '../resources/model/search/ICurrency';
import { Yii } from '../../interfaces/Yii';

@Injectable()
export class HotelCurrencyService {

    public getCurrencyWithDecimals(
        currenciesData: ICurrencies,
        configSharedHotel: IConfigSharedHotel
    ): ICurrency {
        const currency : string = this.getCurrencyString(currenciesData, configSharedHotel);
        return currency ? currenciesData[currency] : null;
    }

    public getCurrencyString(
        currenciesData: ICurrencies | ICurrencyWithPrice,
        configSharedHotel: IConfigSharedHotel
    ): string {
        if (!configSharedHotel){
            return null;
        }

        const currencies : string[] = currenciesData ? Object.keys(currenciesData) : [];
        // For now we can't return two currencies for penalties without a big enhancement in wenji's side
        if (currencies.length === 1) {
            return currencies[0];
        }
        return this.isProviderMainCurrency(configSharedHotel) ?
            this.getProviderCurrencyString(currenciesData) : 'EUR';
    }

    public getProviderCurrencyString(
        currenciesData: ICurrencies | ICurrencyWithPrice
    ): string {
        const currencies : string[] = currenciesData ? Object.keys(currenciesData) : [];
        return currencies.filter((currency: string) => currency !== 'EUR')[0];
    }

    public showAsideCurrency(configSharedHotel: IConfigSharedHotel): boolean {
        return Boolean(
            this.isProviderCurrencyConfigDefined(configSharedHotel) &&
            configSharedHotel.detail.quote.host.cost.hostCurrency.showAsideCurrency
        );
    }

    public isProviderMainCurrency(configSharedHotel: IConfigSharedHotel): boolean {
        return Boolean(
            this.isProviderCurrencyConfigDefined(configSharedHotel) &&
            configSharedHotel.detail.quote.host.cost.hostCurrency.isMainCurrency
        );
    }

    private isProviderCurrencyConfigDefined = (configSharedHotel: IConfigSharedHotel): boolean => {
        return Boolean(configSharedHotel &&
            configSharedHotel.detail &&
            configSharedHotel.detail.quote &&
            configSharedHotel.detail.quote.host &&
            configSharedHotel.detail.quote.host.cost &&
            configSharedHotel.detail.quote.host.cost.hostCurrency);
    }

}